import cn from 'classnames';
import React, { memo } from 'react';

import { Card } from '@sravni/react-design-system';

import { EmptyBoxIcon } from '@src/components/icons';

import styles from './styles.module.scss';

export interface IMessage {
    title: string;
    message: string;
}

interface IProps extends IMessage {
    className?: string;
}

export const MessageBlock: React.FunctionComponent<IProps> = memo(({ className, title, message }) => (
    <Card className={cn(styles.wrapper, className)}>
        <EmptyBoxIcon className={styles.image} />

        {title ? <div className={styles.title}>{title}</div> : null}
        {message ? <div className={styles.message}>{message}</div> : null}
    </Card>
));
